var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{key:_vm.$route.fullPath,on:{"loading":function($event){return _vm.$emit('loading', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }